module.exports = "pegasus_template/assets/themecapture1/charity/110.png";